export class CardConfigs {
    setConfig(mainCardConfig, miniCardConfig) {
        this.mainConfig = mainCardConfig;
        this.miniConfig = miniCardConfig;
    }
    getConfig(isMini) {
        return isMini ? this.miniConfig : this.mainConfig;
    }
    getCardConfigBySportId(sportId, isMini) {
        const config = this.getConfig(isMini);
        return config[sportId];
    }
}
//# sourceMappingURL=CardConfig.js.map